module.exports = __webpack_public_path__ + "img/f1-2.cf8c5b0f.png";